import React from 'react';
import { Container, Row, Col } from 'reactstrap';
import logo from '../../assets/images/logo-dark.png';

const Footer = () => {
  return (
    <footer className="footer__home">
      <Container>
        <Row className="footer__main">
          <Col lg={4} className="footer__brand">
            <div className="footer__logo">
              <img
                src={logo}
                alt="SOS Dottore"
                style={{ width: '150px', height: 'auto', marginBottom: '10px' }}
              />
            </div>
            <p className="footer__description" style={{ float: 'left' }}>
              La salute a portata di smartphone per te e per tutta la tua
              famiglia
            </p>
            <div className="footer__social">
              <a href="#" className="social-link" aria-label="Facebook">
                <i className="fa fa-fw fa-facebook"></i>
              </a>
              <a href="#" className="social-link" aria-label="Instagram">
                <i className="fa fa-fw fa-instagram"></i>
              </a>
              <a href="#" className="social-link" aria-label="LinkedIn">
                <i className="fa fa-fw fa-linkedin"></i>
              </a>
            </div>
          </Col>
          <Col lg={8}>
            <Row>
              <Col md={4} className="footer__section">
                <h4 className="footer__section-title">Supporto</h4>
                <ul className="footer__links">
                  <li>
                    <a href="mailto:info@mediadatafactory.com">Contatti</a>
                  </li>
                  <li>
                    <a
                      href="/privacy-policy.html"
                      target="_blank"
                      rel="noopener noreferrer">
                      Privacy Policy
                    </a>
                  </li>
                  <li>
                    <a
                      href="https://www.iubenda.com/termini-e-condizioni/21991191"
                      target="_blank"
                      rel="noopener noreferrer">
                      Termini e Condizioni
                    </a>
                  </li>
                </ul>
              </Col>
            </Row>
          </Col>
        </Row>
        <Row className="footer__bottom">
          <Col md={6} className="footer__contact">
            <a
              href="mailto:info@mediadatafactory.com"
              className="footer__contact-item">
              <i className="fa fa-fw fa-envelope mr-1"></i>
              <span>
                <a href="mailto:info@mediadatafactory.com">
                  info@mediadatafactory.com
                </a>
              </span>
            </a>
          </Col>
          <Col md={6} className="footer__copyright">
            <p>
              &copy; {new Date().getFullYear()} Media Data Factory SRL. Tutti i
              diritti riservati. P.IVA: 09595010969
            </p>
          </Col>
        </Row>
      </Container>
    </footer>
  );
};

export default Footer;
